module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("RtuAw"))).then(() => module.bundle.root('iDabs'));